import { Header, HeaderOptionItem } from '@appkit4/react-components/header';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import AvatarDropdown from './AvatarDropdown';
import { AppRoutes } from '../../Constants';
import useLocale from '../../locale/useLocale';
import { useGetV1Version } from '../../api/generated/endpoint';
import './Navigation.scss';
import NavigateToHistoryModal from '../pages/newDeclaration/modals/NavigateToHistoryModal/NavigateToHistoryModal';
import { useState } from 'react';

const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth();
    const { l } = useLocale();
    const [navigateToHistoryModalVisible, setNavigateToHistoryModalVisible] =
        useState(false);

    const { data: versionInfo, isLoading: isLoadingVersionInfo } =
        useGetV1Version();

    const titleTemplate = () => (
        <Link
            to={
                auth.isAuthenticated
                    ? AppRoutes.HomePage
                    : AppRoutes.LandingPage
            }
            style={{ fontWeight: 'normal', textDecorationLine: 'none' }}
        >
            {l('_applicationName')}
        </Link>
    );

    const optionsTemplate = () => {
        let versionLabel = '';
        if (versionInfo?.versionTag) {
            versionLabel = `${l('_version')} : ${versionInfo.versionTag}`;
        } else if (versionInfo?.branchName && versionInfo?.commitId) {
            versionLabel = `${l('_version')} : ${versionInfo?.branchName} - ${
                versionInfo?.commitId
            }`;
        }

        const isVisible =
            location.pathname !== AppRoutes.HomePage &&
            location.pathname !== AppRoutes.LogoutPage &&
            location.pathname !== AppRoutes.LandingPage &&
            location.pathname !== '/login/callback';

        const createNewDeclarationIsVisible =
            location.pathname !== AppRoutes.CreateDeclaration &&
            !location.pathname.endsWith('/edit');

        const navigateToHistory = () => {
            if (
                location.pathname === AppRoutes.CreateDeclaration ||
                location.pathname.endsWith('/edit')
            ) {
                setNavigateToHistoryModalVisible(true);
            } else {
                navigate(AppRoutes.History);
            }
        };

        return (
            <>
                {auth.isAuthenticated ? (
                    <>
                        {createNewDeclarationIsVisible ? (
                            <HeaderOptionItem
                                label="Create New Declaration"
                                onClick={() =>
                                    navigate(AppRoutes.CreateDeclaration)
                                }
                                iconName="Appkit4-icon icon-plus-outline"
                            />
                        ) : null}

                        <HeaderOptionItem
                            label="History"
                            onClick={navigateToHistory}
                            iconName="Appkit4-icon icon-time-outline"
                        />
                    </>
                ) : null}
            </>
        );
    };

    const userTemplate = () =>
        auth.isAuthenticated ? <AvatarDropdown /> : null;

    const handleLogoNavigation = () =>
        auth.isAuthenticated
            ? navigate(AppRoutes.HomePage)
            : navigate(AppRoutes.LandingPage);

    const headerStyle = {
        top: '0',
    };

    return (
        <>
            <Header
                role="navigation"
                hasLogo
                type="solid"
                titleTemplate={titleTemplate}
                optionsTemplate={optionsTemplate}
                userTemplate={userTemplate}
                onClickLogo={handleLogoNavigation}
                className="position-sticky"
                style={headerStyle}
                responsive={true}
            />
            <NavigateToHistoryModal
                visible={navigateToHistoryModalVisible}
                setVisible={setNavigateToHistoryModalVisible}
            />
        </>
    );
};

export default Navigation;
